export enum USER_TYPE {
  GUEST = -1,
  NORMAL = 0,
  NORMAL_FROM_GUEST = 1,
  COUPON_ADMIN = 2,
  SUPER_ADMIN = 3,
}
